module.exports = __webpack_public_path__ + "img/vision.8d5f522b.png";